module.exports = __webpack_public_path__ + "static/media/seriousQuestion.2fc34800.mp3";